import styles from '@/styles/topReview/interestedItem.module.scss'
import Image from 'next/image'
import Link from 'next/link'

interface ProductItem {
  productID: string;
  name: string;
  url: string;
  imgUrl: string;
  reviewCount: number;
  price: number;
  normalPrice: number;
  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  position?: number,
  location?: string;
  isEmailOnly: any,
  promotionTypeID: string | number;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    promotionRate: number;
  };
  review: {
    avgRank: number;
    total: number;
  };
  shortDescription?: string;
  visitor?: {
    weeklyVisitors: number
  }
  rankNum?: number;
}

export default function TopReviewInterestedItem(props: ProductItem) {
  return (
    <>
      <Link 
        href={`${props.url}`}
        passHref
        legacyBehavior
      >
        <a rel="noopener noreferrer">
          <div className={styles['comp-top-interested-item']}>
            <div className={styles['image-box']}>
              <Image
                className={styles['product-img']}
                src={props.imgUrl}
                alt={props.name}
                width={79}
                height={79}></Image>
              
              <div className={styles['hot-rank']}>
                Top {props.rankNum}
              </div>
            </div>

            <div className={styles['product-info']}>
              <div className={styles['product-name']}>{props.name}</div>
              <div className={styles['price']}>
                ${props.price}
              </div>
              {
                !!(props.normalPrice && props.price !== props.normalPrice) &&
                <div className={styles['normal-price']}>
                  ${props.normalPrice}
                </div>
              }
            </div>
          </div>
        </a>
      </Link>
    </>
  )
}